export default import.meta.ROLLDOWN_FILE_URL_BkGiSm9VMCHvyaVi0Ppa3A